module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	fox.registerWidget('Unsubscribe', {

		configure: function(options) {
			this.registerOptions('', {
				'!autoRender': false,
				template: 'unsubscribe_form',
				newSelect: true,
				widgets: {
					weeklyUpdatesSelect: {
						widget: 'Control_Select',
						container: '.weekly-updates',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						select: {
							container: '.mc-form-field',
							options: [
								{title: 'Send me updates only for models i subscribe', value: 1},
								{title: 'Send me all models updates', value: 2}
							]
						}
					},
					getSettingsApi: {
						widget: 'Api',
						method: 'Site.getAvailiableInteractionFeatures'
					},
					setSettingsApi: {
						widget: 'Api',
						method: 'Site.getAvailiableInteractionFeatures'
					}
				},
				handleDom: {
					form: {
						target: 'form',
						event: 'submit',
						callback: '_submit'	
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			var hash = fox.Navigator.get(1);

			this.getSettings(hash);
			this.callParent('running', arguments);
		},

		getSettings: function(hash) {
			this.wom1('#getSettingsApi')
				.psend({hash: hash})
				.then(function(e, params, performer) {
					this.setData({
						weekly: 1,
						newModel: 1
					});
					this.render();
				}.bind(this))
				.catch(function() {

				}.bind(this));
		},

		setSettings: function() {
			var data = {
				hash: fox.Navigator.get(1),
				weekly: this.wom1('#weeklyUpdatesSelect').getValue(),
				newModel: this.dom1('[name="new_model"]').checked
			};

			this.wom1('#getSettingsApi')
				.psend({data: data})
				.then(this.handleUpdateSuccess.bind(this))
				.catch(function() {

				}.bind(this));
		},

		setData: function(data) {
			this.wom1('#weeklyUpdatesSelect').setValue(data.weekly);

			this.setTemplateOptions({newModel: data.newModel});
			this.render();
		},

		_submit: function(el, w, alias, e) {
			e.preventDefault();

			this.setSettings();

			return false;
		},

		handleUpdateSuccess: function() {
			console.log('SUCCESS!!!');
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/unsubscribe.js
// module id = 78
// module chunks = 5